import { FunctionComponent } from 'react';

const TableSkeletonLoader: FunctionComponent = () => {
  return (
    <div
      role="status"
      className="animate-pulse"
    >
      {/* Table Header Skeleton */}
      <div className="min-w-full rounded-lg border border-gray-200 bg-white text-sm shadow-sm">
        <div className="bg-gray-100 px-2 py-1">
          <div className="flex space-x-4">
            <div className="h-4 w-24 rounded bg-gray-300 dark:bg-gray-600"></div>
            <div className="h-4 w-20 rounded bg-gray-300 dark:bg-gray-600"></div>
            <div className="h-4 w-24 rounded bg-gray-300 dark:bg-gray-600"></div>
            <div className="h-4 w-32 rounded bg-gray-300 dark:bg-gray-600"></div>
          </div>
        </div>
        
        {/* Table Rows Skeleton */}
        {Array.from({ length: 10 }).map((_, index) => (
          <div key={index} className="border-t border-gray-200 px-2 py-1">
            <div className="flex space-x-4">
              <div className="h-4 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-4 w-20 rounded bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-4 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-4 w-32 rounded bg-gray-200 dark:bg-gray-700"></div>
            </div>
          </div>
        ))}
      </div>
      <span className="sr-only">Loading table...</span>
    </div>
  );
};

export default TableSkeletonLoader;
